import { useState } from 'react';
import AuthorizedPersons from './AuthorizedPersons';
import { useTranslation } from 'react-i18next';
import AddEditAuthorizedPerson from './AddEditAuthorizedPerson';
import LoadingSpinner from '../../Components/LoadingSpinner';
import { useCustomer } from '../../../Providers/CustomerProvider';
import YesNoMessageModal from '../../Components/Modals/YesNoMessageModal';
import useCheckUserRole from '../../BasketPage/Hooks/useCheckUserRole.ts';
import { UserRole } from '../../../Data/UserRolesEnum.ts';
import { useParams } from '../../../Providers/ParamsProvider.jsx';

const AuthorizedPersonsCard = ({ authorizedPersons, loading }) => {
  const [showMessage, setShowMessage] = useState(false)
  const [recNo, setRecNo] = useState(0)
  const { deletePersonAuthorizedToCollectDelivery, handleGetPeopleAuthorizedToCollectDelivery } = useCustomer()
  const { t } = useTranslation()
  const [handlingUser, setHandlingUser] = useState({ name: '', surname: '', position: '', email: '', phoneNumber: '', recNo: 0, isExpAuthorization: false, expirationDate: '' });
  const [isAddPersonVisible, setIsAddPersonVisible] = useState(false);
  const { isUserHasAccess } = useCheckUserRole()
  const { isMobile } = useParams()

  const handleAddPersonButtonClick = () => {
    setIsAddPersonVisible(true);
  }

  const handleEdit = (user) => {
    setHandlingUser({ name: user.name, surname: user.surname, position: user.position, email: user.email.trim(), phoneNumber: user.phoneNumber, recNo: user.recNo, isExpAuthorization: user.effectiveDate ? true : false, expirationDate: user.effectiveDate ? user.effectiveDate : '' })
    setIsAddPersonVisible(true);
  }

  const handleDelete = (user) => {
    setRecNo(user.recNo)
    setShowMessage(true)
  }

  const onHide = async (answer) => {
    setShowMessage(false)
    if (answer) {
      await deletePersonAuthorizedToCollectDelivery(recNo)
      handleGetPeopleAuthorizedToCollectDelivery()
    } else {
      setRecNo(0)
    }
  }

  return (
    <div>
      <div className='row justify-content-center'>
        <div className='col-12 col-xxl-8 mt-2'>
          <div className='justify-content-center'>
            <div className='main-container-holder'>
              <AddEditAuthorizedPerson handlingUser={handlingUser} setHandlingUser={setHandlingUser} isAddPersonVisible={isAddPersonVisible} setIsAddPersonVisible={setIsAddPersonVisible} />
              <div className='panel-header-title'>Osoby upoważnione do odbioru towaru</div>
              <div className='table-responsive'>
                <table className={`${isMobile ? 'table-font-small' : ''} table table-bordered`}>
                  <thead>
                    <tr>
                      <th style={{ width: '2%', textAlign: 'center' }}>LP</th>
                      <th style={{ width: '20%' }}>IMIĘ I NAZWISKO</th>
                      <th style={{ width: '16%' }}>STANOWISKO</th>
                      <th style={{ width: '20%' }}>NUMER KONTAKTOWY</th>
                      <th style={{ width: '19%' }}>E-MAIL</th>
                      <th style={{ width: '19%' }}>TERMIN WAŻNOŚCI</th>
                      <th style={{ width: '2%', textAlign: 'center' }}></th>
                      <th style={{ width: '2%', textAlign: 'center' }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {!loading && <AuthorizedPersons users={authorizedPersons} onEdit={handleEdit} onDelete={handleDelete} />}
                  </tbody>
                </table>
                {(authorizedPersons.length === 0 && authorizedPersons && !loading) && <div style={{ textAlign: 'center' }}>{t("no_data_authorized_person")}</div>}
              </div>
              <YesNoMessageModal show={showMessage} onHide={onHide} title={'Usuwanie osoby upoważnionej'} message={'Czy na pewno chcesz usunąć osobę upoważnioną do odbioru?'} />
              {loading && <LoadingSpinner />}
              {isUserHasAccess(UserRole.Admin) && <button className='btn-app-secondary mt-3' onClick={handleAddPersonButtonClick}>
                Dodaj nową osobę
              </button>}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AuthorizedPersonsCard;